<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_774_2636)">
      <path d="M0 10.56C0 5.58067 0 3.09467 1.54 1.54C3.102 0 5.588 0 10.56 0H11.44C16.4193 0 18.9053 0 20.46 1.54C22 3.102 22 5.588 22 10.56V11.44C22 16.4193 22 18.9053 20.46 20.46C18.898 22 16.412 22 11.44 22H10.56C5.58067 22 3.09467 22 1.54 20.46C0 18.898 0 16.412 0 11.44V10.56Z" fill="#427AA9"/>
      <path d="M11.704 15.8473C6.68803 15.8473 3.82803 12.4153 3.71069 6.69532H6.23336C6.31403 10.89 8.16203 12.6647 9.62869 13.0313V6.69532H11.9974V10.3107C13.442 10.1567 14.9674 8.50666 15.4807 6.68799H17.842C17.6495 7.62942 17.2649 8.52103 16.7122 9.30711C16.1596 10.0932 15.4507 10.7569 14.63 11.2567C15.5459 11.7125 16.3548 12.3574 17.0032 13.1486C17.6517 13.9399 18.125 14.8597 18.392 15.8473H15.7887C15.2314 14.1093 13.838 12.76 11.9974 12.5767V15.8473H11.7114H11.704Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_774_2636">
        <rect width="22" height="22" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
name: "VKIcon"
}
</script>
